import * as i0 from '@angular/core';
import * as i1 from './datepicker.module';
import * as i2 from '@angular/cdk/bidi';
import * as i3 from '@angular/cdk/scrolling';
import * as i4 from '@angular/cdk/overlay';
import * as i5 from '@angular/cdk/portal';
import * as i6 from '../cdk/overlay/mapping';
import * as i7 from '../cdk/overlay/overlay-container';
import * as i8 from '../calendar/calendar.component';
import * as i9 from '../calendar/calendar-range.component';
import * as i10 from './datepicker.directive';
import * as i11 from './datepicker-container.component';
import * as i12 from './datepicker.component';
import * as i13 from '../cdk/overlay/overlay.module';
import * as i14 from '../calendar/calendar.module';
import * as i15 from '../calendar/calendar-range.module';
export const NbDatepickerModuleNgFactory:i0.NgModuleFactory<i1.NbDatepickerModule> = (null as any);
var _decl0_0:i2.Dir = (<any>(null as any));
var _decl0_1:i3.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_2:i3.CdkScrollable = (<any>(null as any));
var _decl0_3:i3.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_4:i3.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_5:i4.CdkConnectedOverlay = (<any>(null as any));
var _decl0_6:i4.CdkOverlayOrigin = (<any>(null as any));
var _decl0_7:i5.CdkPortal = (<any>(null as any));
var _decl0_8:i5.CdkPortalOutlet = (<any>(null as any));
var _decl0_9:i6.NbPortalDirective = (<any>(null as any));
var _decl0_10:i6.NbPortalOutletDirective = (<any>(null as any));
var _decl0_11:i7.NbOverlayContainerComponent = (<any>(null as any));
var _decl0_12:i8.NbCalendarComponent<any> = (<any>(null as any));
var _decl0_13:i9.NbCalendarRangeComponent<any> = (<any>(null as any));
var _decl0_14:i10.NbDatepickerDirective<any> = (<any>(null as any));
var _decl0_15:i11.NbDatepickerContainerComponent = (<any>(null as any));
var _decl0_16:i12.NbDatepickerComponent<any> = (<any>(null as any));
var _decl0_17:i12.NbRangepickerComponent<any> = (<any>(null as any));
var _decl0_18:i13.NbOverlayModule = (<any>(null as any));
var _decl0_19:i14.NbCalendarModule = (<any>(null as any));
var _decl0_20:i15.NbCalendarRangeModule = (<any>(null as any));
var _decl0_21:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_22:i0.ElementRef<any> = (<any>(null as any));
function _View_NbDatepickerContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_15.top;
  currVal_0;
  const currVal_1:any = _decl0_15.right;
  currVal_1;
  const currVal_2:any = _decl0_15.bottom;
  currVal_2;
  const currVal_3:any = _decl0_15.left;
  currVal_3;
}
function _View_NbDatepickerContainerComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_NbDatepickerComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_NbDatepickerComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_NbRangepickerComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_NbRangepickerComponent_3_0():void {
  var _any:any = (null as any);
}
